import { obtenirUrlControleur } from '../utils/urlUtils';
import fetch from '../utils/fetch';
import { ResultatRechercheDto } from '../modeles/ResultatRechercheDto';

const lienRecherche = obtenirUrlControleur('recherche');

export default class RechercheApi {
    static async rechercher(terme: string): Promise<ResultatRechercheDto[]> {
        if (!terme || !terme.trim()) return [];
        const data = await fetch(`${lienRecherche}/api/recherche?terme=${encodeURIComponent(terme.trim())}`, { method: 'GET' }) as ResultatRechercheDto[];
        return Array.isArray(data) ? data : [];
    }
}
